module.exports = __webpack_public_path__ + "img/russia.e7e3f746.svg";